module.exports = __webpack_public_path__ + "img/IMG_2643.67640cc9.gif";